import { render, staticRenderFns } from "./documentype.vue?vue&type=template&id=65f1bc70"
import script from "./documentype.vue?vue&type=script&lang=js"
export * from "./documentype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports